import styled from "styled-components";

export const ColorContainer = styled.div`
  width: 25px;
  height: 25px;
  border-radius: 50%;
  -webkit-box-shadow: 0 0 10px 1px rgba(127, 127, 127, 0.4);
  box-shadow: 0 0 10px 1px rgba(127,127,127,0.4);
  background-color: ${props => props.color};
  
  &.active {
    border: 2px solid dodgerblue;
  }
`;

export const ColorTitle = styled.small`
  font-size: .65rem;
  color: var(--main-text-color);
`;
